/* Lumora cart helpers: reliable "Check out" + "Continue shopping" (cart page, popup, drawer) */
(function () {
  'use strict';
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var KEY = 'lu_last_shop';

  function isCartPath(p) { return /\/cart\/?$/.test(p) || /\/checkouts?\//.test(p); }
  try {
    if (!isCartPath(location.pathname)) sessionStorage.setItem(KEY, location.pathname + location.search);
  } catch (e) {}

  function backUrl(fallback) {
    var u = '';
    try { u = sessionStorage.getItem(KEY) || ''; } catch (e) {}
    if (u && !/\/products\/.*\.(js|json)$/.test(u)) return u;
    return fallback || root;
  }

  /* In the theme editor / preview frame Shopify does not allow checkout inside the frame, so it opens in a new tab. */
  var framed = false, designMode = false;
  try { designMode = !!(window.Shopify && window.Shopify.designMode); framed = designMode || window.top !== window.self; } catch (e) { framed = true; }

  /* Checkout cannot open inside the theme editor (Shopify blocks it): say so instead of opening a broken tab */
  function editorNotice() {
    var n = document.getElementById('lu-editor-note');
    if (!n) {
      n = document.createElement('div'); n.id = 'lu-editor-note'; n.setAttribute('role', 'status');
      n.style.cssText = 'position:fixed;left:50%;bottom:24px;transform:translateX(-50%);z-index:99999;max-width:min(92vw,420px);background:#111;color:#fff;padding:12px 16px;border-radius:12px;font:14px/1.4 system-ui,sans-serif;box-shadow:0 8px 30px rgba(0,0,0,.3);text-align:center';
      n.textContent = 'Checkout cannot open inside the theme editor (Shopify restriction). It works on your live store - copy the link and open it in a new tab: ';
      var cp = document.createElement('button'); cp.type = 'button'; cp.textContent = 'Copy checkout link';
      cp.style.cssText = 'display:block;margin:8px auto 0;padding:6px 12px;border-radius:8px;border:0;background:#fff;color:#111;font:600 13px system-ui,sans-serif;cursor:pointer';
      cp.onclick = function () { var u = location.origin + root + 'checkout'; try { navigator.clipboard.writeText(u).then(function () { cp.textContent = 'Copied'; }, function () { cp.textContent = u; }); } catch (e) { cp.textContent = u; } };
      n.appendChild(cp);
      document.body.appendChild(n);
    }
    n.hidden = false; clearTimeout(n.__t); n.__t = setTimeout(function () { n.hidden = true; }, 6000);
  }

  /* Accept-the-policy gate: false = blocked, true = accepted, null = no policy on this page */
  function policyGate() {
    var boxes = document.querySelectorAll('[data-lu-policy]'); if (!boxes.length) return null;
    var req = false, ok = true, first = null;
    boxes.forEach(function (w) {
      if (w.getAttribute('data-required') !== 'true') return;
      req = true; var b = w.querySelector('[data-lu-pol-box]');
      if (b && !b.checked) { ok = false; if (!first) first = w; var e = w.querySelector('[data-lu-pol-err]'); if (e) e.hidden = false; w.classList.remove('is-shake'); void w.offsetWidth; w.classList.add('is-shake'); }
    });
    if (!req) { var any = false; boxes.forEach(function (w) { var b = w.querySelector('[data-lu-pol-box]'); if (b && b.checked) any = true; }); return any ? true : null; }
    if (!ok) { if (first && first.scrollIntoView) first.scrollIntoView({ block: 'center', behavior: 'smooth' }); return false; }
    return true;
  }
  var POLK = 'lu-pol';
  function polState() { try { return sessionStorage.getItem(POLK) === '1'; } catch (e) { return false; } }
  function applyPol() {
    var on = polState();
    document.querySelectorAll('[data-lu-pol-box]').forEach(function (b) { if (!b.__luP) { b.__luP = true; b.checked = on; } });
  }
  document.addEventListener('change', function (e) {
    var b = e.target && e.target.closest && e.target.closest('[data-lu-pol-box]'); if (!b) return;
    try { sessionStorage.setItem(POLK, b.checked ? '1' : '0'); } catch (x) {}
    document.querySelectorAll('[data-lu-pol-box]').forEach(function (o) { o.checked = b.checked; });
    document.querySelectorAll('[data-lu-pol-err]').forEach(function (m) { if (b.checked) m.hidden = true; });
  });

  /* Special order instructions: saved to the cart note while typing */
  var noteT = 0;
  function saveNote(v) { clearTimeout(noteT); noteT = setTimeout(function () { fetch(root + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: v }) }).catch(function () {}); }, 450); }
  document.addEventListener('input', function (e) {
    var t = e.target && e.target.closest && e.target.closest('[data-lu-note-input]'); if (!t) return;
    document.querySelectorAll('[data-lu-note-input]').forEach(function (o) { if (o !== t) o.value = t.value; });
    document.querySelectorAll('[data-lu-note-cnt]').forEach(function (c) { c.textContent = t.value.length; });
    saveNote(t.value);
  });
  document.addEventListener('click', function (e) {
    var ch = e.target && e.target.closest && e.target.closest('[data-lu-chip]'); if (!ch) return;
    e.preventDefault();
    var w = ch.closest('[data-lu-note]'), t = w && w.querySelector('[data-lu-note-input]'); if (!t) return;
    var add = ch.getAttribute('data-lu-chip'), cur = t.value.trim();
    if (cur.toLowerCase().indexOf(add.toLowerCase()) === -1) t.value = (cur ? cur + '. ' : '') + add + '.';
    t.dispatchEvent(new Event('input', { bubbles: true })); t.focus();
  });
  var fT = 0;
  new MutationObserver(function () { clearTimeout(fT); fT = setTimeout(applyPol, 50); }).observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState !== 'loading') applyPol(); else document.addEventListener('DOMContentLoaded', applyPol);

  function closeNotice() {
    var n = document.getElementById('cart-notification');
    if (n) n.classList.remove('active');
    var cn = document.querySelector('cart-notification');
    if (cn && cn.close) { try { cn.close(); } catch (e) {} }
    var cd = document.querySelector('cart-drawer');
    if (cd && cd.close && cd.classList.contains('active')) { try { cd.close(); } catch (e) {} }
    document.body.classList.remove('overflow-hidden');
  }

  function a0(t) { return !!t.closest('a'); }
  document.addEventListener('click', function (e) {
    var t = e.target; if (!t || !t.closest) return;

    /* Check out */
    var c = t.closest('[name="checkout"], #checkout, .cart__checkout-button');
    if (c && !c.disabled && c.getAttribute('aria-disabled') !== 'true') {
      e.preventDefault(); e.stopImmediatePropagation();
      var pol = policyGate();
      if (pol === false) return;
      var f = c.form || document.getElementById('cart');
      var note = f && f.querySelector('[name="note"]');
      var lun = document.querySelector('[data-lu-note-input]');
      var body = {};
      if (lun) body.note = lun.value; else if (note && note.value) body.note = note.value;
      if (pol === true) { var dt = new Date(); body.attributes = { 'Policy accepted': 'Yes - ' + dt.toISOString().slice(0, 16).replace('T', ' ') + ' UTC' }; }
      var go = function () {
        var url = root + 'checkout';
        if (designMode) { editorNotice(); return; }
        if (framed) { try { window.top.location.href = new URL(url, location.href).href; return; } catch (e) {} }
        window.location.assign(url);
      };
      if (Object.keys(body).length) {
        fetch(root + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) }).then(go, go);
      } else go();
      return;
    }

    /* Continue shopping (popup button, drawer button, cart page links) */
    var s = t.closest('cart-notification .link.button-label, cart-notification .cart-notification__links button[type="button"], button[data-lu-continue]');
    if (s) { e.preventDefault(); e.stopImmediatePropagation(); closeNotice(); if (framed && a0(t)) return; if (document.body.getAttribute('data-lu-cart-page') === '1' || isCartPath(location.pathname)) window.location.assign(backUrl()); return; }

    var a = t.closest('a[data-lu-continue]');
    if (a && !framed) {
      e.preventDefault(); e.stopImmediatePropagation(); closeNotice();
      window.location.assign(a.getAttribute('data-fallback') ? backUrl(a.getAttribute('data-fallback')) : backUrl());
    }
  }, true);

  /* v79: "Customers also bought" - add to cart without leaving the page */
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest && e.target.closest('[data-lu-up-add]'); if (!b || b.disabled) return;
    e.preventDefault(); b.disabled = true;
    var old = b.textContent; b.textContent = '...';
    fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: Number(b.getAttribute('data-lu-up-add')), quantity: 1 }] }) })
      .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
      .then(function () {
        var cd = document.querySelector('cart-drawer');
        if (cd && cd.renderContents && document.getElementById('CartDrawer') && b.closest('cart-drawer')) {
          return fetch(root + '?sections=cart-drawer,cart-icon-bubble').then(function (r) { return r.json(); }).then(function (s) { cd.renderContents({ sections: s }); });
        }
        if (b.closest('#cart-notification-extras')) {
          return fetch(root + '?sections=cart-notification-extras,cart-icon-bubble').then(function (r) { return r.json(); }).then(function (j) {
            [['cart-notification-extras', 'cart-notification-extras'], ['cart-icon-bubble', 'cart-icon-bubble']].forEach(function (p) {
              var el = document.getElementById(p[0]); if (!el || !j[p[1]]) return;
              var d = new DOMParser().parseFromString(j[p[1]], 'text/html'); var sec = d.querySelector('.shopify-section');
              el.innerHTML = p[0] === 'cart-icon-bubble' ? (sec ? sec.innerHTML : el.innerHTML) : d.body.innerHTML;
            });
          });
        }
        /* cart page: repaint lines, totals, discount bar and header count in place */
        var ci = document.querySelector('cart-items');
        if (ci && typeof ci.refreshSections === 'function') {
          return ci.refreshSections().then(function () { b.disabled = false; b.textContent = old; });
        }
        window.location.reload();
      })
      .catch(function () { b.disabled = false; b.textContent = old; });
  });

  /* v83: active discount bar - the fill animates when items change, congratulation effect when a new step is reached */
  var CB = { n: null, tier: null, pct: 0 };
  try { var sv = JSON.parse(sessionStorage.getItem('lu-cb') || 'null'); if (sv) CB = sv; } catch (e) {}
  function saveCB() { try { sessionStorage.setItem('lu-cb', JSON.stringify(CB)); } catch (e) {} }
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function confetti(bar) {
    if (reduce) return;
    var box = document.createElement('span'); box.className = 'lu-cb-fx'; box.setAttribute('aria-hidden', 'true');
    var cols = ['#ff4d6d', '#ffb703', '#2ec4b6', '#5b3df5', '#ff9f1c', '#3a86ff', '#8ac926'];
    cols.push(getComputedStyle(bar).getPropertyValue('--cb') || '#5b3df5');
    for (var i = 0; i < 44; i++) {
      var p = document.createElement('i'), a = Math.random() * Math.PI - Math.PI, d = 70 + Math.random() * 140;
      p.style.setProperty('--x', Math.round(Math.cos(a) * d * 1.4) + 'px');
      p.style.setProperty('--y', Math.round(Math.sin(a) * d - 30) + 'px');
      p.style.setProperty('--r', Math.round(Math.random() * 720 - 360) + 'deg');
      p.style.setProperty('--c', cols[i % cols.length]);
      p.style.setProperty('--dl', (Math.random() * 0.15).toFixed(2) + 's');
      p.style.left = (35 + Math.random() * 30) + '%';
      box.appendChild(p);
    }
    bar.appendChild(box);
    setTimeout(function () { if (box.parentNode) box.parentNode.removeChild(box); }, 2200);
  }
  function celebrate(bar) {
    var fx = bar.getAttribute('data-fx') || 'confetti'; if (fx === 'none') return;
    bar.classList.add('is-pop'); setTimeout(function () { bar.classList.remove('is-pop'); }, 1800);
    if (fx === 'confetti') confetti(bar);
    var msg = bar.querySelector('.lu-cartbar__msg'), gift = bar.querySelector('.lu-cartbar__gift'), tpl = bar.getAttribute('data-congrats');
    if (msg && tpl) {
      var keep = msg.innerHTML, keepG = gift ? gift.textContent : '';
      msg.textContent = ''; var parts = tpl.split(/(\[reward\])/);
      parts.forEach(function (x) { if (x === '[reward]') { var b = document.createElement('strong'); b.textContent = bar.getAttribute('data-reward') || ''; msg.appendChild(b); } else if (x) msg.appendChild(document.createTextNode(x)); });
      if (gift) gift.textContent = '🎉';
      bar.classList.add('is-cong');
      setTimeout(function () { if (!bar.isConnected) return; msg.innerHTML = keep; if (gift) gift.textContent = keepG; bar.classList.remove('is-cong'); }, 4200);
    }
  }
  function scanBars() {
    var fresh = []; document.querySelectorAll('[data-lu-cartbar]').forEach(function (b) { if (!b.__luSeen) { b.__luSeen = true; fresh.push(b); } });
    if (!fresh.length) return;
    var last = fresh[fresh.length - 1], n = parseInt(last.getAttribute('data-n'), 10) || 0, tier = parseInt(last.getAttribute('data-tier'), 10) || 0, pct = parseFloat(last.getAttribute('data-pct')) || 0;
    var up = CB.tier !== null && tier > CB.tier;
    fresh.forEach(function (b) {
      var fill = b.querySelector('.lu-cartbar__fill'); if (!fill) return;
      var from = CB.n === null ? 0 : CB.pct;
      fill.style.transition = 'none'; fill.style.width = from + '%';
      var marks = b.querySelectorAll('.lu-cartbar__m'); var ptier = CB.tier === null ? 0 : CB.tier;
      marks.forEach(function (m, i) { if (m.classList.contains('is-on') && i >= ptier && up) { m.classList.remove('is-on'); setTimeout(function () { m.classList.add('is-on', 'is-pop'); }, 450 + i * 120); } });
      void fill.offsetWidth;
      fill.style.transition = ''; fill.style.width = pct + '%';
      if (up) setTimeout(function () { celebrate(b); }, 650);
    });
    CB = { n: n, tier: tier, pct: pct }; saveCB();
  }
  var bt = 0;
  new MutationObserver(function () { clearTimeout(bt); bt = setTimeout(scanBars, 60); }).observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState !== 'loading') scanBars(); else document.addEventListener('DOMContentLoaded', scanBars);
})();
